import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import Loader from '../loader/Loader';
import MachineDailyStatusButton from '../machine/MachineDailyStatusButton';

const { Content } = Layout;

/**
 * Layout do PWA dos operadores (Operador e Operador-comprador).
 *
 * Sem header/top bar — o app ocupa a tela toda, dando máxima área útil ao
 * fluxo. A navegação de volta para a Home acontece por botões "Voltar"
 * dentro do conteúdo de cada tela de fluxo, e "Meu perfil"/"Sair" vivem como
 * cards na própria Home (OperatorHome).
 *
 * Não há menu lateral/gaveta — a navegação acontece pela Home com botões.
 * O MachineDailyStatusButton (botão flutuante) fica visível em todas as telas
 * do app e abre a gaveta com o balanço diário de litros por máquina
 * (ocupação vs capacidade).
 */
const OperatorLayout = () => (
  <Layout style={{ backgroundColor: '#1b3663', minHeight: '100vh', height: '100vh', boxSizing: 'border-box', paddingTop: 'env(safe-area-inset-top)' }}>
    <Loader />

    <Layout style={{ background: '#fff', display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      <MachineDailyStatusButton />
      <Content
        style={{
          flex: 1,
          width: '100%',
          maxWidth: 720,
          margin: '0 auto',
          padding: 16,
          overflow: 'auto',
          overflowX: 'hidden',
          paddingBottom: 'calc(32px + env(safe-area-inset-bottom))',
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  </Layout>
);

export default OperatorLayout;
